import { Label } from '@ui-library/typography';
import React from 'react';
import { ReactComponent as Tick } from '@svg/tick.svg';
import pricelineLogo from '@png/pricelineLogo.png';
import hinge from '@png/hinge.png';
import acornslogo from '@png/acornslogo.png';
import crateAndBarrel from '@png/crateAndBarrel.png';
import barstool from '@png/barstool.png';
import iftt from '@png/iftt.png';
import sky from '@png/sky.png';
import wynn from '@png/wynn.png';
import anheuser from '@png/anheuser.png';
import tonalLogo from '@png/tonalLogo.png';
import { Flex } from '@ui-library/misc';
import theme from '@css/theme';
import classes from '../signup.module.scss';

const content: { [index: string]: string } = {
  'Warehouse first': 'Get all the functionality of a CDP & maintain full ownership of your data.',
  'Open-source': 'No vendor lock-in or black boxes.',
  'DevOps for CDP':
    'Use our APIs and Github workflows to manage pipelines and governance in your existing infrastructure.',
  'Transparent pricing': 'No MTUs and no cliffs, just volume.',
};

const images: React.ReactElement[][] = [
  [
    <img src={pricelineLogo} style={{ maxWidth: '100%' }} alt="priceline" />,
    <img src={iftt} style={{ maxWidth: '100%' }} alt="iftt" />,
  ],
  [
    <img src={hinge} style={{ maxWidth: '100%' }} alt="hinge" />,
    <img src={sky} style={{ maxWidth: '100%' }} alt="sky" />,
  ],
  [
    <img src={acornslogo} style={{ maxWidth: '100%' }} alt="acorns" />,
    <img src={wynn} style={{ maxWidth: '100%' }} alt="wynn" />,
  ],
  [
    <img src={crateAndBarrel} style={{ maxWidth: '100%' }} alt="crate&Barrel" />,
    <img src={anheuser} style={{ maxWidth: '100%' }} alt="anheuser" />,
  ],
  [
    <img src={barstool} style={{ maxWidth: '100%' }} alt="barstool" />,
    <img src={tonalLogo} style={{ maxWidth: '100%' }} alt="tonal" />,
  ],
];

const Promotion = () => (
  <Flex flexDirection="column" className={classes.promotion}>
    <table>
      <thead>
        <tr>
          <td>
            <Label fontWeight={700} fontSize="20px" lineHeight="22px" color={theme.color.neutral2}>
              The Customer Data Platform for Developers
            </Label>
          </td>
        </tr>
      </thead>
      <tbody style={{ borderTop: '40px solid transparent' }}>
        <tr style={{ borderBottom: '40px solid transparent' }} />
        {Object.entries(content).map(([k, v], i) => (
          <tr
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'flex-start',
              borderBottom: '20px solid transparent',
            }}
            key={i}
          >
            <td style={{ paddingRight: '16px' }}>
              <Tick />
            </td>
            <td>
              <Label
                fontWeight={700}
                fontSize="16px"
                lineHeight="22px"
                color={theme.color.neutral1}
              >
                {k}:
              </Label>
              <Label
                fontWeight={400}
                fontSize="16px"
                lineHeight="22px"
                color={theme.color.neutral1}
              >
                &nbsp;
                {v}
              </Label>
            </td>
          </tr>
        ))}
      </tbody>
    </table>

    <Flex flexDirection="column" style={{ marginTop: '116px' }}>
      <div style={{ marginBottom: '50px' }}>
        <Label fontWeight={700} fontSize="20px" lineHeight="22px" color={theme.color.neutral2}>
          We process critical customer data for top companies in the world
        </Label>
      </div>
      <Flex flexDirection="row" justifyContent="space-between">
        {images.map((arr: React.ReactElement[], key: number) => (
          <Flex
            flexDirection="column"
            style={{ height: '100px', justifyContent: 'space-around' }}
            key={key}
          >
            {arr.length > 0 && arr.map((img: React.ReactElement) => img)}
          </Flex>
        ))}
      </Flex>
    </Flex>
  </Flex>
);

export default Promotion;
